import fetch from "../utils/fetch";
const baseURL = process.env.VUE_APP_API_CLOUD_URL

/**
 * 提交需求
 * @param {*} query
 */
export function insert(data) {
  return fetch({
    url: "/homeDemand/insert",
    method: "post",
    data,
  });
}

/**
 * 获取新闻咨询列表
 * @param {*} query
 */
export function listInfo(page,data) {
   const { pageNum = 1, numPerPage = 50 } = page
  return fetch({
    url: `homeInfo/listInfo?pageNum=${pageNum}&numPerPage=${numPerPage}`,
    method: "post",
    data,
  });
}

/**
 * 提交申请试用需求
 * @param {*} query
 */
export function freeSupplyInsert(data) {
  return fetch({
    url: "/freeSupply/insert",
    method: "post",
    data,
    baseURL,
  });
}
/**
 * 手机号码验证
 * @param {*} query
 */
export function verPhone(data) {
  return fetch({
    url: "/freeSupply/verPhone",
    method: "post",
    data,
    baseURL,
  });
}

/**
 * 获取新闻咨询详情
 * @param {*} query
 */
export function infoDetail(data) {
  return fetch({
    url: `/homeInfo/infoDetail-${data}`,
    method: "post",
    data,
  });
}

/**
 * 在线留言提交
 * @param {*} query
 */
export function msgInsert(data) {
  return fetch({
    url: "/home/msg/insert",
    method: "post",
    data,
  });
}


/**
 * 获取首页配置
 * @param {*} query
 */
export function getConf() {
  return fetch({
    url: "/homeConf/getConf",
    method: "post",
    data:{moduleTypeList:[
      "logo",
      "lunbo",
      "card",
      "timeline",
      "why",
      "people",
      "text",
      "content",
      "message",
      "productHeader",
      "productContect",
      "productPriceImage",
      "newHeader",
      "customerHeader",
      "weHeader",
      "aboutUs",
      "onlineFixed",
      "onlineAnswer",
      "sidePhone",
      "sideCard",
       'brand',
      'price',
    ]}
  });
}


